import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import "tachyons";
import "animate.css";
// Phone / tablet layout. Last of the global sheets so it wins over them.
import "./responsive.css";

// Import all components directly to ensure proper loading
import ProductList from "./Components/ProductList";
import TableRent from "./Components/tables/TableForRent/TableRent";
import AddProduct from "./Components/tables/Addproduct/AddProduct";
import InputWakel from "./Components/tables/addWakel/InputWakel";
import AllKoga3arz from "./Components/tables/Raporty3arz/AllKoga3arz";
import AllKogamawad from "./Components/tables/MawadDetail/AllKogamawad";
import TakeMoney from "./Components/tables/TakeMoney/TakeMoney";
import AddUser from "./Navbar/Adduser/AddUser";
import Setting from "./Components/tables/Setting/Setting";
import Login from "./Components/Form/Login";
import TableRentAllPrint from "./Components/printTables/PrintRent/TableRentAllPrint";
import InputPrintWakel from "./Components/printTables/PrintWakel/InputPrintWakel";
import PrintAllTakeMoney from "./Components/printTables/TakeMoneyPrint/PrintAllTakeMoney";
import AllKoga from "./Components/tables/GaranawaBoKoga/AllKoha";
import TableAllprintgaranawa from "./Components/printTables/printGaranawa/TableAllprintgaranawa";
import AllQazanj from "./Components/tables/Qazanj/AllQazanj";
import ModelQazanj from "./Components/tables/Qazanj/ModelQazanj";
import ProductRaportAll from "./Components/ProductRaportAll";
import ModelRaportKoga from "./Components/tables/RaportyKoga/ModelRaportKoga";
import ModelRozhana from "./Components/tables/RaportyRozhana/ModelRozhana";
import ModelWakel from "./Components/tables/Raportywakel/ModelWakel";
import AllRozhana from "./Components/tables/RaportyRozhana/AllRozhana";
import AllWakelRaport from "./Components/tables/Raportywakel/AllWakelRaport";
import AllQarzWakel from "./Components/tables/RaportyQarzeWakel/AllQarzWakel";
import AllKogaRaport from "./Components/tables/RaportyKoga/AllKogaRaport";
import ModelKalaRaport from "./Components/tables/RaportyKala/ModelKalaRaport";
import AllKalaRaport from "./Components/tables/RaportyKala/AllKalaRaport";
import AllQarzRastawxo from "./Components/tables/RaportyQarzeRastawxo/AllQarzRastawxo";
import ModalQarzRastawxo from "./Components/tables/RaportyQarzeRastawxo/ModalQarzRastawxo";
import AddProductCin from "./Components/tables/RaportyCin/AddProductCin";
import InputRaportyWakel from "./Components/printTables/PrintRaportyWakel/InputRaportyWakel";
import InputRaportyRozhana from "./Components/printTables/PrintRaportyRozhana.js/InputRaportyRozhana";
import AllKalayNafroshraw from "./Components/tables/RaportykalayNafroshraw/Allkalaynafroshraw";
import ModelKalayNafroshraw from "./Components/tables/RaportykalayNafroshraw/ModelKalayNafroshraw";
import AllParayNagarawa from "./Components/tables/RaportyParayNagarawa/AllParayNagarawa";
import ModelParayNagarawa from "./Components/tables/RaportyParayNagarawa/ModelParayNagarawa";
import MasrufatAll from "./Components/MasrufatAll";
import Paradan from "./Components/tables/Paradan/Paradan";
import InputMasruf from "./Components/tables/msruf/InputMasruf";
import InputPeople from "./Components/tables/AddPeople/InputPeople";
import Paradarhenan from "./Components/tables/paradarhenan/Paradarhenan";
import Mandub from "./Components/tables/Mandub/Mandub";
import AllParadan from "./Components/tables/RaportyParadan/AllParadan";
import AllParayDarhenraw from "./Components/tables/RaportyParayDarhenraw/AllParayDarhenraw";
import AllMasrufat from "./Components/tables/raportymasrufat/AllMasrufat";
import ModelOfParadan from "./Components/tables/RaportyParadan/ModelOfParadan";
import ModelOfParayDarhenraw from "./Components/tables/RaportyParayDarhenraw/ModelOfParayDarhenraw";
import ModelOfMasrufat from "./Components/tables/raportymasrufat/ModelOfMasrufat";
import AllKasRaport from "./Components/tables/RaportyKasakan/AllKasRaport";
import ModelKas from "./Components/tables/RaportyKasakan/ModelKas";
import AllMandub from "./Components/tables/RaportyMandub/AllMandub";
import ModelOfMandub from "./Components/tables/RaportyMandub/ModelOfMandub";
import Parawargrtn from "./Components/tables/Parawargrtn/Parawargrtn";
import AllParawargrtnawakan from "./Components/tables/raportyParawargrtnawa/AllParawargrtnawakan";
import ModelOfParawargrtnawakan from "./Components/tables/raportyParawargrtnawa/ModelOfParawargrtnawakan";
import PrintAllMandub from "./Components/printTables/PrintMandub/PrintAllMandub";
import PrintAllParadan from "./Components/printTables/printParadan/PrintAllParadan";
import PrintAllParadarhenan from "./Components/printTables/PrintParadarhenan/PrintAllParadarhenan";
import PrintAllParawargrtn from "./Components/printTables/Parawargrtn/PrintAllParawargrtn";
import ParaGorenawa from "./Components/tables/ParaGorenawa/ParaGorenawa";
import AllParaGorenawa from "./Components/tables/RaportyParaGorinawa/AllParaGorenawa";
import ModelParaGorenawa from "./Components/tables/RaportyParaGorinawa/ModelParaGorenawa";
import IpadCardAll from "./Components/IpadCards/IpadCardAll";
import HeaderIpad from "./Components/tables/TableForRent/RentIpad/HeaderIpad";
import RozhanaHeader from "./Components/tables/RaportyRozhana/IpadRozhanaRaport/RozhanaHeader";
import AddCin from "./Components/tables/RaportyCin/IpadCin/AddCin";
import InputPrint from "./Components/printTables/ParayNagarawa/InputPrint";
import InputPrintMove from "./Components/printTables/ParayDarhenrawRaport/InputPrintMove";
import InputPrintDan from "./Components/printTables/ParadanPrintRaport/InputPrintDan";
import InputPrintMasruf from "./Components/printTables/PrintRaportyMasrufat/InputPrintMasruf";
import InputPrintMawad from "./Components/printTables/PrintMawadDetail/InputPrintMawad";
import InputParaGorenawa from "./Components/printTables/PrintRaportyParaGorenawa/InputParaGorenawa";
import InputMandubPrint from "./Components/printTables/PrintRaportyMandub/InputMandubPrint";
import InputGarandnawa from "./Components/printTables/PrintRaportyGarandawa/InputGarandnawa";
import InputKas from "./Components/printTables/PrintRaportyKas/InputKas";
import G_HeaderIpad from "./Components/tables/GaranawaBoKoga/GaranawaIpad/G_HeaderIpad";
import FormzyadkrdniRasid from "./Components/tables/AddWakilOldRasid/FormzyadkrdniRasid";
import AllWaslRemembe from "./Components/tables/RaportyBasRemembe/AllWaslRemembe";
import ModelWasleRemembe from "./Components/tables/RaportyBasRemembe/ModelWasleRemembe";
import InputRprint from "./Components/printTables/PrintRaportyWaslRemembe/InputRprint";
import KoyQarziAsto from "./Components/tables/KoyQarziAsto/KoyQarziAsto";
import QarziAstoModel from "./Components/tables/KoyQarziAsto/QarziAstoModel";
import AllCom from "./Components/tables/TesxtOnBord/AllCom";
import Body from "./Components/printTables/PrintRaffa/Body";
import InputPrintArz from "./Components/printTables/Raporty3arz/InputPrintArz";
import InputPrintKoga from "./Components/printTables/RaportyKoga/InputPrintKoga";
import ModelKoga3arz from "./Components/tables/Raporty3arz/ModelKoga3arz";
import AllAuditLog from "./Components/AuditLog/AllAuditLog";
import AllOrders from "./Components/Orders/AllOrders";
import AllStorefront from "./Components/Storefront/AllStorefront";
import AllCategory from "./Components/Category/AllCategory";
import IncomOut from "./Components/tables/TotalInOut/IncomOut";
import TotalnOut from "./Components/tables/TotalInOut/TotalnOut";
import InOut from "./Components/printTables/TotalInOtPrint/InOut";
import AllRozhanaMawad from "./Components/tables/RaportyRozhanaMawad/AllRozhanaMawad";
import RozhanMawadModel from "./Components/tables/RaportyRozhanaMawad/RozhanMawadModel";
import PrintArabic from "./Components/printTables/PrintRent/PrintArabic";
import PrintArabicMoney from "./Components/printTables/TakeMoneyPrint/PrintArabicMoney";
import PriceUpdate from "./Components/tables/PriceUpdate/PriceUpdate";
import PrintArabicSingle from "./Components/printTables/PrintSingleSale/PrintArabicSingle";
import AllSinglePrint from "./Components/printTables/PrintSingleSale/AllSinglePrint";
import AllMarket from "./Components/tables/SaleMarket/AllMarket";
import { EditModel } from "./Components/tables/SaleMarket/EditModel";
import { ProductConsumer } from "./Context/AddProWakel";

// Loading component
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
    <div className="spinner-border text-primary" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);
function App() {
  return (
    <ProductConsumer>
      {(value) => {
        const { role, JK_kompanyakan, JK_paradan } = value;
        return (
          <Router>
            <div className="App">
              {localStorage.token ? (
                <Redirect from="/login" to="/" />
              ) : (
                <Redirect from="/" to="/login" />
              )}

              <Switch>
                <Suspense fallback={<LoadingSpinner />}>
                <Route exact path="/login" component={Login} />
                <Route exact path="/IncomeOutCome" component={IncomOut} />
                <Route
                  exact
                  path="/Product-Raport"
                  component={ProductRaportAll}
                />
                {role == "ipad" || role == "ipadadmin" ? (
                  <Route exact path="/" component={IpadCardAll} />
                ) : (
                  <Route exact path="/" component={ProductList} />
                )}
                <Route exact path="/print-Koga" component={InputPrintKoga} />
                <Route exact path="/print-kas" component={InputKas} />
                <Route exact path="/print-3arz" component={InputPrintArz} />
                <Route exact path="/text-bord" component={AllCom} />
                <Route exact path="/text-print" component={Body} />
                <Route exact path="/RozhanaMawad" component={AllRozhanaMawad} />
                <Route exact path="/MarketSale" component={AllMarket} />
                <Route
                  exact
                  path="/print-mandub-raport"
                  component={InputMandubPrint}
                />
                <Route
                  exact
                  path="/print-garanawa"
                  component={InputGarandnawa}
                />
                <Route
                  exact
                  path="/print-masruf"
                  component={InputPrintMasruf}
                />
                <Route exact path="/print-mawad" component={InputPrintMawad} />
                <Route
                  exact
                  path="/print-paragorenawa"
                  component={InputParaGorenawa}
                />
                <Route
                  exact
                  path="/print-paradan-raport"
                  component={InputPrintDan}
                />
                <Route exact path="/print-hesabatKarga" component={InOut} />
                <Route
                  exact
                  path="/print-paraynagarawa"
                  component={InputPrint}
                />
                <Route
                  exact
                  path="/print-paraydarhenraw"
                  component={InputPrintMove}
                />
                <Route exact path="/rent" component={TableRent} />
                <Route exact path="/ipad-rozhana" component={RozhanaHeader} />
                <Route exact path="/ipad-rent" component={HeaderIpad} />
                <Route exact path="/Raport-china" component={AddProductCin} />
                <Route exact path="/ipad-cin" component={AddCin} />
                <Route exact path="/add-product" component={AddProduct} />
                <Route exact path="/add-wakel" component={InputWakel} />
                <Route exact path="/take-money" component={TakeMoney} />
                <Route exact path="/All-Koga-3arz" component={AllKoga3arz} />
                <Route exact path="/All-Koga-detail" component={AllKogamawad} />
                <Route exact path="/add-user" component={AddUser} />
                <Route exact path="/setting" component={Setting} />
                <Route exact path="/print-rent" component={TableRentAllPrint} />
                <Route exact path="/print-rent-Arabic" component={PrintArabic} />
                <Route exact path="/print-money-Arabic" component={PrintArabicMoney} />
                <Route exact path="/PriceUpdate" component={PriceUpdate} />
                <Route exact path="/print-single-Arabic" component={PrintArabicSingle} />
                <Route exact path="/print-single" component={AllSinglePrint} />
                <Route
                  exact
                  path="/print-garanawa-koga"
                  component={TableAllprintgaranawa}
                />
                <Route exact path="/print-wakel" component={InputPrintWakel} />
                <Route
                  exact
                  path="/print-takemoney"
                  component={PrintAllTakeMoney}
                />
                <Route exact path="/back-koga" component={AllKoga} />
                <Route exact path="/Raport-qazanj" component={AllQazanj} />
                <Route
                  exact
                  path="/Raport-rozhana"
                  render={() => (
                    <AllRozhana
                      JK_kompanyakan={JK_kompanyakan}
                      JK_paradan={JK_paradan}
                    />
                  )}
                />
                <Route exact path="/Raport-wakel" component={AllWakelRaport} />
                <Route
                  exact
                  path="/Raport-qarzeWakel"
                  component={AllQarzWakel}
                />
                <Route
                  exact
                  path="/Raport-kogajard"
                  component={AllKogaRaport}
                />
                <Route exact path="/Raport-kala" component={AllKalaRaport} />
                <Route
                  exact
                  path="/Raport-qarzrastawxo"
                  component={AllQarzRastawxo}
                />
                <Route
                  exact
                  path="/print-raportywakel"
                  component={InputRaportyWakel}
                />
                <Route
                  exact
                  path="/print-raportyRozhana"
                  component={InputRaportyRozhana}
                />
                <Route
                  exact
                  path="/raporty-kalaynafroshraw"
                  component={AllKalayNafroshraw}
                />
                <Route
                  exact
                  path="/raporty-paraynadraw"
                  component={AllParayNagarawa}
                />
                <Route exact path="/masrufat" component={MasrufatAll} />
                <Route exact path="/Paradan" component={Paradan} />
                <Route exact path="/Paradarhenan" component={Paradarhenan} />
                <Route exact path="/input-masruf" component={InputMasruf} />
                <Route exact path="/input-people" component={InputPeople} />
                <Route exact path="/Mandub" component={Mandub} />
                <Route exact path="/raporty-paradan" component={AllParadan} />
                <Route
                  exact
                  path="/raporty-paraydarhenraw"
                  component={AllParayDarhenraw}
                />
                <Route exact path="/raporty-masrufat" component={AllMasrufat} />
                <Route exact path="/raporty-kasakan" component={AllKasRaport} />
                <Route exact path="/raporty-mandubakan" component={AllMandub} />
                <Route exact path="/parawargrtn" component={Parawargrtn} />
                <Route
                  exact
                  path="/raporty-parawargrtn"
                  component={AllParawargrtnawakan}
                />
                <Route exact path="/print-mandub" component={PrintAllMandub} />
                <Route
                  exact
                  path="/print-paradan"
                  component={PrintAllParadan}
                />
                <Route
                  exact
                  path="/print-paradarhenan"
                  component={PrintAllParadarhenan}
                />
                <Route
                  exact
                  path="/print-parawargrtn"
                  component={PrintAllParawargrtn}
                />
                <Route exact path="/change-money" component={ParaGorenawa} />
                <Route
                  exact
                  path="/raporty-change"
                  component={AllParaGorenawa}
                />
                <Route exact path="/ipad-garanawa" component={G_HeaderIpad} />
                <Route exact path="/old-rasid" component={FormzyadkrdniRasid} />
                <Route exact path="/bas-remembe" component={AllWaslRemembe} />
                <Route
                  exact
                  path="/print-bas-remembe"
                  component={InputRprint}
                />
                  <Route exact path="/qarziasto" component={KoyQarziAsto} />
                  <Route exact path="/audit-log" component={AllAuditLog} />
                  <Route exact path="/online-orders" component={AllOrders} />
                  <Route exact path="/storefront" component={AllStorefront} />
                  <Route exact path="/categories" component={AllCategory} />
                </Suspense>
              </Switch>
            </div>
            <Suspense fallback={<LoadingSpinner />}>
              <ModelOfParawargrtnawakan />
              <ModelOfMandub />
              <ModelQazanj />
              <ModelRozhana />
              <ModelWakel />
              <ModelRaportKoga />
              <ModelKalaRaport />
              <ModalQarzRastawxo />
              <ModelKalayNafroshraw />
              <ModelParayNagarawa />
              <ModelOfParadan />
              <ModelOfParayDarhenraw />
              <ModelOfMasrufat />
              <ModelKas />
              <ModelParaGorenawa />
              <ModelWasleRemembe />
              <QarziAstoModel />
              <ModelKoga3arz />
              <TotalnOut />
              <RozhanMawadModel />
              <EditModel />
            </Suspense>

          </Router>
        );
      }}
    </ProductConsumer>
  );
}

export default App;
